import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, session } from "../api.js";
import { Icon } from "./icons.jsx";

const POLL_MS = 30000;

export default function NotificationBell() {
  const me = session.get()?.user;
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const ref = useRef(null);

  const load = () =>
    api("/notifications")
      .then((d) => {
        setItems(d.items);
        setUnreadCount(d.unreadCount);
      })
      .catch(() => {
        /* brak powiadomień nie może wywrócić reszty nawigacji */
      });

  useEffect(() => {
    if (!me) return;
    load();
    const t = setInterval(load, POLL_MS);
    return () => clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [me?.id]);

  /* klik poza dropdownem i Escape — ten sam wzorzec co navgroup w Header.jsx */
  useEffect(() => {
    const onDown = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", onDown);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDown);
      document.removeEventListener("keydown", onKey);
    };
  }, []);

  if (!me) return null;

  const caseUrl = (id) => (me.role === "client" ? `/sprawa/${id}` : `/prawnik/sprawa/${id}`);

  const openItem = async (n) => {
    setOpen(false);
    if (!n.read_at) {
      setItems((list) => list.map((x) => (x.id === n.id ? { ...x, read_at: new Date().toISOString() } : x)));
      setUnreadCount((c) => Math.max(0, c - 1));
      api(`/notifications/${n.id}/read`, { method: "POST" }).catch(() => {});
    }
    if (n.case_id) nav(caseUrl(n.case_id));
    else if (n.event === 'chat_message') nav(me.role === 'admin' ? '/admin/czat' : '/prawnik/czat');
  };

  const markAllRead = async (e) => {
    e.stopPropagation();
    setItems((list) => list.map((x) => ({ ...x, read_at: x.read_at || new Date().toISOString() })));
    setUnreadCount(0);
    try {
      await api("/notifications/read-all", { method: "POST" });
    } catch {
      /* nieszkodliwe — odświeży się przy kolejnym pollu */
    }
  };

  return (
    <div className="navgroup" ref={ref}>
      <button
        type="button"
        className="bell-btn"
        aria-expanded={open}
        aria-haspopup="true"
        aria-label={unreadCount ? `Powiadomienia (${unreadCount} nowych)` : "Powiadomienia"}
        onClick={() => setOpen((v) => !v)}
      >
        <Icon name="dzwonek" size={20} />
        {unreadCount > 0 && <span className="bell-badge">{unreadCount > 9 ? "9+" : unreadCount}</span>}
      </button>
      {open && (
        <div className="drop bell-drop" role="menu">
          <div className="bell-head">
            <b>Powiadomienia</b>
            {unreadCount > 0 && (
              <button type="button" className="link-btn" onClick={markAllRead}>
                Oznacz wszystkie jako przeczytane
              </button>
            )}
          </div>
          {!items.length && <p className="hint bell-empty">Brak powiadomień.</p>}
          {items.map((n) => (
            <button
              type="button"
              key={n.id}
              className={`bell-item${n.read_at ? "" : " unread"}`}
              onClick={() => openItem(n)}
            >
              <span>{n.message}</span>
              <em>{new Date(n.created_at).toLocaleString("pl-PL")}</em>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
